import * as api from "@/api/williams/report";
import { PrintDialog } from "../dialogs";
import { ScopeOfWork } from "@/api/williams/scopesOfWork";
import { ScopeOfWorkPrintOptions } from "@/api/williams/report";
import { useModalDialog } from "@/hooks";

export function usePrintScope() {
  const dialog = useModalDialog();

  function showDialog(scope: ScopeOfWork) {
    dialog.show(PrintDialog, {
      onAccept: (options: ScopeOfWorkPrintOptions) => api.printScopeOfWork(scope, options),
    });
  }

  return { showDialog };
}
